import { PropsWithChildren, useState } from "react";
import { DialogResponsive } from "@/components/common/dialogs";
import { Deal } from "@/types";
import { FormDeal } from "./form-deal";

type FormDealModalProps = PropsWithChildren & {
  deal?: Deal;
  openDrawer?: boolean;
  disable?: boolean;
};

export function FormDealModal({
  children,
  deal,
  disable
}: FormDealModalProps) {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DialogResponsive
      title={deal ? "Atualizar oportunidade" : "Nova oportunidade"}
      description={
        deal
          ? "Preencha os campos para atualizar a oportunidade."
          : "Preencha os campos para criar uma nova oportunidade."
      }
      button={children}
      disable={disable}
      defaultOpen={open}
      setDefaultOpen={setOpen}
    >
      <FormDeal deal={deal} handleClose={handleClose} />
    </DialogResponsive>
  );
}